// @core/api/endpoints/analytics/list_dashboards.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListDashboardsResponse,
} from '../../../types/analytics';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/analytics';

/**
 * List dashboards
 * Returns dashboards visible to the current user based on visibility settings.
 */
export async function ListDashboards(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListDashboardsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/analytics/dashboards`;
  const requestOptions = options;
  return client.get<ListDashboardsResponse>(requestPath, { ...requestOptions, params });
}
